export const DATA_RECEIVE = 'DATA_RECEIVE';
export const DATES_RECEIVE = 'DATES_RECEIVE';
export const ERROR_RECEIVE = 'ERROR_RECEIVE';
export const META_RECEIVE = 'META_RECEIVE';
